module.exports = __webpack_public_path__ + "img/left.675c18c8.png";